function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 125"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M23 48a2 2 0 100 4h54a2 2 0 000-4z",
  style: {
    textIndent: "0",
    textTransform: "none",
    blockProgression: "tb"
  },
  overflow: "visible",
  color: "#000"
})));